// extracted by mini-css-extract-plugin
export default {"usage-product-tabs":"UsageProductTabs_usage-product-tabs__yPMg5","usage-product-tabs__tab":"UsageProductTabs_usage-product-tabs__tab__QZ+qL"};